import { clearObject } from "@/functions/helpers.js";

export default {
  getFeed(context, params = null) {
    return new Promise((resolve, reject) => {
      let queryString = params ? new URLSearchParams(params) : "";
      window.axios
        .get(`m/feed?${queryString}`)
        .then(response => {
          context.commit("setFeed", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getCategories(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("courses/categories")
        .then(response => {
          context.commit("setCategories", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getAll(context, params) {
    const queryString = new URLSearchParams(params).toString();
    context.commit("setCount", 0);

    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/?${queryString}`)
        .then(response => {
          context.commit("setCourses", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  getFeatured(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/filter/feature?limit=6")
        .then(response => {
          context.commit("setFeatured", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getDetails(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/${id}`)
        .then(response => {
          context.commit("setCourse", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getResource(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/resources/${id}`)
        .then(response => {
          context.commit("setResource", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getArchives(context, { id, params }) {
    const queryString = new URLSearchParams(clearObject(params)).toString();

    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/sources/${id}?${queryString}`)
        .then(response => {
          context.commit("setArchives", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  getLesson(context, { course_id, lesson_id }) {
    return new Promise((resolve, reject) => {
      Promise.all([
        window.axios.get(`/courses/1/lesson/${lesson_id}`),
        window.axios
          .get(`/courses/lessons?id=${lesson_id}&limit=1`)
          .catch(() => ({ data: { results: [] } }))
      ])
        .then(([lessonResponse, categoryResponse]) => {
          const categoryCache =
            categoryResponse.data.results?.[0]?.category_cache;

          context.commit("setLesson", {
            ...lessonResponse.data,
            category_cache: categoryCache || null
          });
          resolve();
        })
        .catch(reject);
    });
  },

  getLive(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/live")
        .then(response => {
          context.commit("setLive", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getLessons(context, params) {
    const queryString = new URLSearchParams(params).toString();
    context.commit("setCount", 0);

    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/lessons?${queryString}`)
        .then(response => {
          context.commit("setLessons", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  searchLessons(context, params) {
    const queryString = new URLSearchParams(params).toString();
    context.commit("setCount", 0);

    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/search?${queryString}`)
        .then(response => {
          context.commit("setLessons", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  getCategoryLessons(context, category) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/lessons?category=${category}&limit=999&is_month=false`)
        .then(response => {
          context.commit("setCategoryLessons", {
            lessons: response.data.results,
            category
          });
          resolve();
        })
        .catch(reject);
    });
  },

  getFreebies(context, params) {
    const queryString = new URLSearchParams(params).toString();
    context.commit("setCount", 0);

    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/lessons/free?${queryString}`)
        .then(response => {
          context.commit("setFreebies", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  getTrails(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/trail")
        .then(response => {
          context.commit("setTrails", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getTrail(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/trail/${id}`)
        .then(response => {
          context.commit("setTrail", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getMicrolearning(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/microlearning/${id}`)
        .then(response => {
          context.commit("setMicrolearning", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getMicrolearnings(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/microlearning`)
        .then(response => {
          context.commit("setMicrolearnings", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  // GET /courses/categories/list
  getHomeCategories(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/categories/list")
        .then(response => {
          context.commit("setHomeCategories", response.data);
          resolve();
        })
        .catch(reject);
    });
  }
};
